import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import SEO from "../../../components/common/SEO";

function ListingDoctors() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    const navigate = useNavigate();

    const [doctors, setDoctors] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState("");

    useEffect(() => {
        fetchDoctors();
    }, []);

    const fetchDoctors = async () => {
        try {
            const token = localStorage.getItem("authToken");
            const response = await axios.get(`${API_BASE_URL}/doctors`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            setDoctors(response.data.data);
        } catch (err) {
            console.error("Error:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure want to delete this doctor?")) return;

        try {
            const token = localStorage.getItem("authToken");
            await axios.delete(`${API_BASE_URL}/doctors/delete/${id}`, {
            headers: { Authorization: `Bearer ${token}` },
            });

            setDoctors((prev) => prev.filter((item) => item.id !== id));
        } catch (err) {
            console.error("Delete error:", err);
        }
    };


    const filteredDoctors = doctors.filter((d) =>
        d.doctor_name.toLowerCase().includes(search.toLowerCase())
    );

    return (
        <div className="card">
            <SEO title="Doctors Management | Mangoloops" />
            <div className="card-header d-flex justify-content-between">
                <h4 className="mb-0">Doctors Listing</h4>
                <div className="d-flex gap-2">
                    <input
                        type="text"
                        placeholder="Search doctor..."
                        className="form-control"
                        style={{ width: 250 }}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <Link to="/admin/add-doctor" className="btn btn-primary">
                        Add Doctor
                    </Link>
                </div>
            </div>

            <div className="card-body">
                <table className="table table-bordered">
                    <thead className="table-light">
                        <tr>
                            <th>#</th>
                            <th>Image</th>
                            <th>Doctor Name</th>
                            <th>Speciality</th>
                            <th>City</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <tr>
                                <td colSpan="6" className="text-center">
                                    Loading...
                                </td>
                            </tr>
                        ) : filteredDoctors.length > 0 ? (
                            filteredDoctors.map((doc, index) => (
                                <tr key={doc.id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        {doc.doctor_images?.length > 0 ? (
                                            <img
                                                src={doc.doctor_images[0].image_url}
                                                alt=""
                                                style={{
                                                    width: 60,
                                                    height: 60,
                                                    objectFit: "cover",
                                                    borderRadius: 4,
                                                }}
                                            />
                                        ) : (
                                            "No Image"
                                        )}
                                    </td>

                                    <td>
                                        <span
                                            style={{ color: "#0d6efd", cursor: "pointer" }}
                                            onClick={() =>
                                                navigate(`/admin/edit-doctor/${doc.id}`)
                                            }
                                        >
                                            {doc.doctor_name}
                                        </span>
                                    </td>

                                    <td>
                                        {doc.sub_speciality?.sub_speciality_name || "N/A"}
                                    </td>

                                    <td>{doc.city}</td>

                                    <td>
                                        <button
                                            onClick={() => handleDelete(doc.id)}
                                            className="btn btn-sm btn-danger"
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center">
                                    No doctors found.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default ListingDoctors;
